// 校验手机号
export function regexPhone(rule, value, callback) {
  if (value === '') {
    callback(new Error('请输入手机号码'));
  } else if (/^1[3456789]\d{9}$/.test(value) === false) {
    callback(new Error('请输入正确的手机号码'));
  } else {
    callback();
  }
}

export function regexPhoneNotReq(rule, value, callback) {
  if (value === '') {
    callback();
  } else if (/^1[3456789]\d{9}$/.test(value) === false) {
    callback(new Error('请输入正确的手机号码'));
  } else {
    callback();
  }
}

// 校验密码
export function regexPwd(rule, value, callback) {
  if (value === '') {
    callback(new Error('请输入密码'));
  } else if (/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/.test(value) === false) {
    callback(new Error('密码需为8-16位英文加数字组合'));
  } else {
    callback();
  }
}

// 校验邮箱
export function regexEmail(rule, value, callback) {
  if (value === '') {
    callback(new Error('请输入邮箱'));
  }
  var reg = /^([a-zA-Z0-9]+[_|\-|.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\-.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}/gi;
  if (reg.test(value) === false) {
    callback(new Error('请输入正确的邮箱'));
  } else {
    callback();
  }
}

// 校验身份证
export function regexIdCard(rule, value, callback) {
  // 15位和18位身份证号码的正则表达式
  var regIdCard = /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[X|x])$)$/;
  // 如果通过该验证，说明身份证格式正确，但准确性还需计算
  if (regIdCard.test(value)) {
    if (value.length === 18) {
      var idCardWi = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]; // 将前17位加权因子保存在数组里
      var idCardY = [1, 0, 10, 9, 8, 7, 6, 5, 4, 3, 2]; // 这是除以11后，可能产生的11位余数、验证码，也保存成数组
      var idCardWiSum = 0; // 用来保存前17位各自乖以加权因子后的总和
      for (var i = 0; i < 17; i++) {
        idCardWiSum += value.substring(i, i + 1) * idCardWi[i];
      }
      var idCardMod = idCardWiSum % 11; // 计算出校验码所在数组的位置
      var idCardLast = value.substring(17); // 得到最后一位身份证号码
      // 如果等于2，则说明校验码是10，身份证号码最后一位应该是X
      if (idCardMod === 2) {
        if (idCardLast === 'X' || idCardLast === 'x') {
          callback();
        } else {
          callback(new Error('身份证号格式填写错误'));
        }
      } else {
        // 用计算出的验证码与最后一位身份证号码匹配，如果一致，说明通过，否则是无效的身份证号码
        if (Number(idCardLast) === Number(idCardY[idCardMod])) {
          callback();
        } else {
          callback(new Error('身份证号格式填写错误'));
        }
      }
    }
  } else {
    callback(new Error('身份证号格式填写错误'));
  }
}

export function regexIdCardNotReq(rule, value, callback) {
  if (value === '') {
    callback();
    return false;
  }
  // 15位和18位身份证号码的正则表达式
  var regIdCard = /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[X|x])$)$/;
  // 如果通过该验证，说明身份证格式正确，但准确性还需计算
  if (regIdCard.test(value)) {
    if (value.length === 18) {
      var idCardWi = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]; // 将前17位加权因子保存在数组里
      var idCardY = [1, 0, 10, 9, 8, 7, 6, 5, 4, 3, 2]; // 这是除以11后，可能产生的11位余数、验证码，也保存成数组
      var idCardWiSum = 0; // 用来保存前17位各自乖以加权因子后的总和
      for (var i = 0; i < 17; i++) {
        idCardWiSum += value.substring(i, i + 1) * idCardWi[i];
      }
      var idCardMod = idCardWiSum % 11; // 计算出校验码所在数组的位置
      var idCardLast = value.substring(17); // 得到最后一位身份证号码
      // 如果等于2，则说明校验码是10，身份证号码最后一位应该是X
      if (idCardMod === 2) {
        if (idCardLast === 'X' || idCardLast === 'x') {
          callback();
        } else {
          callback(new Error('身份证号格式填写错误'));
        }
      } else {
        // 用计算出的验证码与最后一位身份证号码匹配，如果一致，说明通过，否则是无效的身份证号码
        if (Number(idCardLast) === Number(idCardY[idCardMod])) {
          callback();
        } else {
          callback(new Error('身份证号格式填写错误'));
        }
      }
    }
  } else {
    callback(new Error('身份证号格式填写错误'));
  }
}

// 校验银行卡
export function regexBankNo(rule, value, callback) {
  if (value === '') {
    callback(new Error('请填写银行账户'));
    return false;
  }
  if (/^([1-9]{0})(\d{16}|\d{19})$/.test(value) === false) {
    callback(new Error('请填写正确格式的银行账户'));
    return false;
  }
  callback();
}

export function regexBankNoNotReq(rule, value, callback) {
  if (value === '') {
    callback();
    return false;
  }
  if (/^([1-9]{0})(\d{16}|\d{19})$/.test(value) === false) {
    callback(new Error('请填写正确格式的银行账户'));
    return false;
  }
  callback();
}
